import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { DatePicker, IDatePickerProps } from './DatePicker';

type Value = IDatePickerProps['value'];
type IDatePickerFieldProps = IDatePickerProps & FieldProps<Value, FieldRenderProps<Value>>;

export const DatePickerField = (props: IDatePickerFieldProps) => (
  <Field {...props}>
    {({ input, meta }) => {
      const error = typeof props.error === 'boolean' ? props.error && meta.error : meta.touched && meta.error;
      return (
        <DatePicker
          {...props}
          {...input}
          invalid={typeof props.invalid === 'boolean' ? props.invalid : Boolean(error)}
          error={props.error ? props.error : error}
        />
      );
    }}
  </Field>
);
